import { render, staticRenderFns } from "./deanOverlay.vue?vue&type=template&id=2fdff360&scoped=true"
import script from "./deanOverlay.vue?vue&type=script&lang=ts"
export * from "./deanOverlay.vue?vue&type=script&lang=ts"
import style0 from "./deanOverlay.vue?vue&type=style&index=0&id=2fdff360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdff360",
  null
  
)

export default component.exports